import config from '../../config';
import { getNavItemsBasedOnCountry, NavItems } from './landingNavItems';

export const useGetLandingNavItems = (): NavItems =>
  getNavItemsBasedOnCountry(config.COUNTRY);
